// extracted by mini-css-extract-plugin
export default {"newsD_d":"NewsDetails_newsD_d__m12nI","newsd":"NewsDetails_newsd__PViYo","newsD_l":"NewsDetails_newsD_l__KDEI+","title":"NewsDetails_title__yq-jp","back":"NewsDetails_back__Bb-TN"};